import { useEffect } from "react";
import { pushLock, popLock } from "../lib/scrollLock";

// Lock body scroll while `active` is true; always releases on unmount.
export function useBodyScrollLock(active) {
  useEffect(() => {
    if (!active) return undefined;
    pushLock();
    return () => popLock();
  }, [active]);
}

export default useBodyScrollLock;
